import { type QueryFunctionContext } from '@tanstack/vue-query';

import type { ApiResponse } from '@abaninja/types';

import { apiClient, httpClient, unwrap } from '@abaninja/util-http-client';

import { type Invitation, type InvitationRequest, type UpdateInvitationPayload } from '../@types';

export function getInvitations(options?: QueryFunctionContext) {
  return unwrap(apiClient.get<ApiResponse<Invitation[]>>('/users/v1/invitations', { signal: options?.signal }));
}

export function inviteUser(data: InvitationRequest) {
  return unwrap(apiClient.post<ApiResponse<Invitation>>('/users/v1/invitations', data));
}

export function revokeInvitation(invitationUuid: string) {
  return unwrap(apiClient.delete(`/users/v1/invitations/${invitationUuid}`));
}

export function getCurrentUserInvitations(options?: QueryFunctionContext) {
  return unwrap(httpClient.get<ApiResponse<Invitation[]>>('/users/v1/me/invitations', { signal: options?.signal }));
}

export function getInvitation(accountUuid: string, invitationUuid: string, options?: QueryFunctionContext) {
  return unwrap(httpClient.get<ApiResponse<Invitation>>(
    `accounts/${accountUuid}/users/v1/invitations/${invitationUuid}`,
    { signal: options?.signal },
  ));
}

export function acceptInvitation({ accountUuid, invitationUuid }: UpdateInvitationPayload) {
  return unwrap(httpClient.post(`accounts/${accountUuid}/users/v1/invitations/${invitationUuid}/accept`));
}

export function declineInvitation({ accountUuid, invitationUuid }: UpdateInvitationPayload) {
  return unwrap(httpClient.post(`accounts/${accountUuid}/users/v1/invitations/${invitationUuid}/decline`));
}
